import MomentUtils from "@date-io/moment";
import {
  Box,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  makeStyles,
  MenuItem,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from "@material-ui/core";
import CloseIcon from '@material-ui/icons/Close';
import DeleteIcon from "@material-ui/icons/Delete";
import LaunchIcon from '@material-ui/icons/Launch';
import LinkIcon from '@material-ui/icons/Link';
import {
  DateTimePicker,
  KeyboardDateTimePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import { MdOutlineFileUpload, MdClose, MdLink } from "react-icons/md";
import { debounce } from "lodash";
import moment from "moment";
import {
  forwardRef,
  Fragment,
  useCallback,
  useEffect,
  useImperativeHandle,
  useMemo,
  useRef,
  useState,
} from "react";
import { BiUpload, BiPlusCircle } from "react-icons/bi";
import { FaRegTrashAlt } from "react-icons/fa";
import { LuChevronDown } from "react-icons/lu";
import { useDispatch } from "react-redux";
import PlusIcon from '../../../../assets/icons/plus.png';
import { handleKeyDown } from "../../../../common/common";
import CustomShowModal from "../../../../components/Common/CustomShowModal";
import CustomTextField from "../../../../components/Common/CustomTextField";
import UploadPDFModal from "../../../../components/Common/UploadPDF";
import AddPortQueryModal from "../../../../components/Orders/AddPortQueryModal";
import {
  addQueryInitialData,
  queryPortDisabledFields,
  termsCoEfficientTable,
} from "../../../../constants";
import {
  getCurrentUserOrganizationId,
  toastError,
  toastSuccess,
} from "../../../../utils";
import * as commonActions from "../../../Common/actions";
import { tagsByCharAPI } from "../../Orders/actions";
import { validateNewQuery } from "../../Orders/addQueryValidation";
import { updateCargo } from "../actions";

const refreshCanalOptions = [
  { label: "Avoid Suez Canal", value: "suez" },
  { label: "Avoid Panama Canal", value: "panama" },
];

const useStyles = makeStyles((theme) => ({
  root: {
    '& .MuiDialog-paper': {
      borderRadius: 12,
      minWidth: '400px',
    }
  },
  dialogTitle: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.common.white,
  },
  dialogContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'start',
    padding: theme.spacing(3),
  },
  linkList: {
    width: '100%',
    maxHeight: '400px',
    overflowY: 'auto',
    borderRadius: theme.spacing(1),
    border: `1px solid ${theme.palette.divider}`,
  },
  linkItem: {
    transition: 'background-color 0.2s ease',
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    }
  }
}));
const CargoViewModel = forwardRef((props, ref) => {
  const {
    setLoader = () => { },
    selectedQuery = {},
    selectedPorts = [],
    selectedPortsCommence = [],
    refetch = () => { },
    onCloseModal = () => { }
  } = props;
  const organizationId = getCurrentUserOrganizationId();
  const contractId =
    selectedQuery?.contractId ||
    selectedQuery?._id ||
    selectedQuery?.cargoContractId ||
    selectedQuery?.id ||
    props?.cargoContractId ||
    props?.contractId ||
    props?._id ||
    props?.id;

  const addPortInitialData = [
    {
      cargoId: "",
      operation: "Loading",
      port: "",
      cargoQty: 0,
      tolerance: 0,
      rate: 0,
      terms: "SHINC",
      turnTime: 0,
      pdaRemarks: "",
      grade: "",
      freight: 0,
      adcom: 0,
      other: 0,
      brokerage: 0,
      ttlComm: 0,
      netFrt: 0,
      min: 0,
      max: 0,
      account: "",
      cargo: "",
      factor: 1,
      stowFactor: 0,
      queryId: "",
      loadline: "S-Summer",
      sulfur: "Normal",
    },
    {
      cargoId: "",
      operation: "Discharging",
      port: "",
      cargoQty: 0,
      tolerance: 0,
      rate: 0,
      terms: "SHINC",
      turnTime: 0,
      pdaRemarks: "",
      grade: "",
      freight: 0,
      adcom: 0,
      other: 0,
      brokerage: 0,
      ttlComm: 0,
      netFrt: 0,
      min: 0,
      max: 0,
      account: "",
      cargo: "",
      factor: 1,
      stowFactor: 0,
      queryId: "",
      loadline: "S-Summer",
      sulfur: "Normal",
    },
  ];

  const dispatch = useDispatch();

  const [portOperations, setPortOperations] = useState([...addPortInitialData]);
  const [query, setQuery] = useState({ ...addQueryInitialData });
  const [portModal, setPortModal] = useState(false);
  const [selectedPort, setSelectedPort] = useState({});
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [getOpenUploadPDF, setOpenUploadPDF] = useState(false);
  const [TempCargoDetails, setTempCargoDetails] = useState({})
  const [AttachmentFiles, setAttachmentFiles] = useState([]);
  const [tagsLoading, setTagsLoading] = useState(false);
  const [TagsOptions, setTagsOptions] = useState([]);
  const fileInputRef = useRef(null);

  const selectedCargoDetails = () => {
    const data = portOperations?.map((portDetails) => ({
      operation: portDetails.operation,
      lat: portDetails?.lat,
      lng: portDetails?.lng,
      port: portDetails?.port,
      cargoQty: portDetails?.cargoQty?.toString(),
      tolerance: portDetails?.tolerance?.toString(),
      rate: portDetails?.rate?.toString(),
      terms: portDetails?.terms,
      turnTime: portDetails?.turnTime?.toString(),
      freight: portDetails?.freight,
      min: portDetails?.min?.toString(),
      max: portDetails?.max?.toString(),
      adcom: portDetails?.adcom?.toString(),
      other: portDetails?.other?.toString(),
      brokerage: portDetails?.brokerage?.toString(),
      account: portDetails?.account,
      cargo: portDetails?.cargo,
      stowFactor: portDetails?.stowFactor?.toString(),

    }));
    const tabledata = data?.filter((field) => (field?.operation === "Loading" || field?.operation === "Discharging"))

    const querydata = {
      queryid: query?._id,
      name: query?.name,
      freightMode: query?.freightMode,
      qtyMode: query?.qtyMode,
      access: query?.access,
      laycanStartDate: query?.laycanStartDate,
      laycanEndDate: query?.laycanEndDate,
      message: query?.message,
      portOperations: tabledata,
      Tag1: query?.Tag1,
      Tag2: query?.Tag2,
      Tag3: query?.Tag3,
      Tag4: query?.Tag4,
    }
    setTempCargoDetails(querydata)
  }

  useEffect(() => {
    selectedCargoDetails()
  }, [portOperations, query])

  useEffect(() => {
    if (Object.keys(selectedQuery).length) {
      setQuery(selectedQuery);
    }
    if (Array.isArray(selectedPorts) && selectedPorts.length) {
      setPortOperations(selectedPorts);
    }
    return () => {
      resetStateVariables();
    };
  }, [selectedQuery, selectedPorts]);

  useEffect(() => {
    const { errors } = validateNewQuery(query, portOperations);
    dispatch(commonActions.addOnlyErrors({ errorList: errors }));
  }, [query, portOperations]);

  const resetStateVariables = () => {
    setPortOperations([...addPortInitialData]);
    setQuery({ ...addQueryInitialData });
    setPortModal(false);
    setSelectedPort({});
    setSelectedIndex(0);
  };

  const onOpenErrorAlert = (errors = []) => {
    dispatch(commonActions.openErrorAlert({ errorList: errors }));
  };
  const debouncedSearch = useCallback(
    debounce((search, type, name) => {
      onSearchTagsList(search, type, name);
    }, 400),
    []
  );

  const onSearchTagsList = (value, type, name) => {
    if (value) {
      setTagsLoading(name);
      tagsByCharAPI(value, type)
        .then((res) => {
          setTagsLoading(false);
          let tagsList = [];
          if (res.data.list?.length > 0) {
            if (type === "individual") {
              tagsList = res.data.list.map((item) => ({
                label: `${item.individual_firstName} (${item?.individual_emailPersonal})`,
                value: item._id,
                name: item.individual_firstName
              }));
            } else {
              tagsList = res.data.list.map((item) => ({
                label: `${item.organisation_fullName} (${item?.organisation_emailOfficial})`,
                value: item._id,
                name: item.organisation_fullName
              }));
            }
          }
          setTagsOptions(tagsList);
        })
        .catch((err) => {
          setTagsLoading(false);
          setTagsOptions([]);
        });
    }
  };


  const delayTagsSearch = (search, type, name) => {
    debouncedSearch(search, type, name);
  };

  useImperativeHandle(ref, () => ({
    async onSubmitQuery(isCopy = false, isShareName = "") {
      const { errors, isValid } = validateNewQuery(query, portOperations);
      if (!isValid) return onOpenErrorAlert(errors);

      const finalPortOperations = [...selectedPortsCommence, ...portOperations];
      const formData = new FormData();

      try {
        let newQuery = {
          ...query,
          laycanStartDate: moment(query.laycanStartDate).toISOString(),
          laycanEndDate: moment(query.laycanEndDate).toISOString(),
          cargoList: finalPortOperations,
          organizationId,
        };

        if (isCopy) {
          newQuery = { ...TempCargoDetails };
          const newPortOperation = [...(TempCargoDetails?.portOperations || [])];
          delete newQuery?.portOperations;

          if (isShareName) {
            newQuery.name = isShareName;
            newQuery.access = "public";
          } else {
            newQuery.access = "private";
          }

          newQuery.cargoList = newPortOperation.map(({ max, min, ...rest }) => rest);
        } else {
          newQuery.cargoList = finalPortOperations.map(({ max, min, ...rest }) => rest);
        }
        const { contractId: id, ...rest } = newQuery
        formData.append('data', JSON.stringify(rest) || '')
        AttachmentFiles.forEach((file, index) => {
          formData.append('files', file);
        });

        const targetId =
          contractId ||
          query?.contractId ||
          query?._id ||
          query?.cargoContractId ||
          query?.id ||
          selectedQuery?.contractId ||
          selectedQuery?._id ||
          selectedQuery?.cargoContractId ||
          selectedQuery?.id ||
          props?.cargoContractId ||
          props?.contractId ||
          props?._id ||
          props?.id;

        await updateCargo({ _id: targetId, cargoContractId: targetId, contractId: targetId }, formData)
        toastSuccess('cargo updated succesfully')
        onCloseModal()
        refetch()
      } catch (ex) {
        setLoader(false);
        console.error("Error in submitting query:", ex);
        toastError('failed to update cargo')
      }
    },
  }));



  const onChangeHandler = (e) => {
    const { value = "", name = "" } = e.target || {};
    if (name === "freightMode") {
      if (value === "Single Freight") {
        const firstLoadingIndex = portOperations.findIndex(
          (item) => item?.operation?.toLowerCase() === "loading"
        );
        const firstLoadPort = firstLoadingIndex !== -1 ? portOperations[firstLoadingIndex] : {};
        setPortOperations(
          portOperations.map((item, index) => {
            if (firstLoadingIndex !== -1 && index !== firstLoadingIndex) {
              if (item?.operation?.toLowerCase() === "loading") {
                return {
                  ...item,
                  freight: firstLoadPort.freight || 0,
                  adcom: firstLoadPort.adcom || 0,
                  other: firstLoadPort.other || 0,
                  brokerage: firstLoadPort.brokerage || 0,
                };
              } else {
                return {
                  ...item,
                  freight: 0,
                  adcom: 0,
                  other: 0,
                  brokerage: 0,
                };
              }
            }
            return item;
          })
        );
      }
    }
    setQuery({ ...query, [name]: value });
  };

  const onChangePortOperation = (index, e) => {
    const { name = "", value = "", type = "" } = e.target;
    let updatedPortOperation = [...portOperations];
    const finalValue = type === "number" ? Number(value) : value;
    updatedPortOperation[index][name] = finalValue;

    if (name === "operation" && value === "Discharging") {
      const disabledFields = queryPortDisabledFields?.[value] || {};
      Object.keys(disabledFields).forEach((field) => {
        if (disabledFields[field]) {
          if (["account", "cargo"].includes(field)) {
            updatedPortOperation[index][field] = "";
          } else {
            updatedPortOperation[index][field] = 0;
          }
        }
      });
    }

    if (name === "terms") {
      const findFactor = termsCoEfficientTable.find(
        (item) => item.label === value
      );

      if (findFactor) {
        updatedPortOperation[index]["factor"] = findFactor.value;
      }
    }

    const firstLoadingIndex = portOperations.findIndex(
      (item) => item?.operation?.toLowerCase() === "loading"
    );
    if (query.freightMode === "Single Freight" && index === firstLoadingIndex) {
      if (["freight", "adcom", "other", "brokerage"].includes(name)) {
        updatedPortOperation = updatedPortOperation.map((item, idx) => {
          if (firstLoadingIndex !== -1 && idx !== firstLoadingIndex && item?.operation?.toLowerCase() === "loading") {
            return {
              ...item,
              [name]: finalValue,
            };
          }
          return item;
        });
      }
    }

    setPortOperations(updatedPortOperation);
  };

  const onAddPortOperations = (index) => {
    const newPortOperations = [...portOperations];
    newPortOperations.splice(index + 1, 0, { ...addPortInitialData[1] });
    setPortOperations(newPortOperations);
  };

  const onDeletePortOperations = (index) => {
    let updatedOperation = [...portOperations];
    updatedOperation.splice(index, 1);
    setPortOperations(updatedOperation);
  };

  const onSelectPortsOfOperations = (port, index) => {
    setSelectedPort(port);
    setSelectedIndex(index);
    setPortModal(true);
  };

  const onSavePortOperationsOfQuery = (port, val) => {
    let updatedPortOperation = [...portOperations];
    updatedPortOperation[selectedIndex]["port"] = port;
    updatedPortOperation[selectedIndex]["lat"] = val?.lat;
    updatedPortOperation[selectedIndex]["lng"] = val?.lng;

    setPortOperations(updatedPortOperation);
    onClosePortModal();
  };

  const onClosePortModal = () => {
    setPortModal(false);
    setSelectedPort({});
    setSelectedIndex(0);
  };

  const onChangeDate = (type, date) => {
    setQuery({ ...query, [type]: date });
  };

  const onSelectTags = (value, name) => {
    setQuery({ ...query, [name]: value });
    setTagsOptions([])
  };
  const onChangeHandlerAccess = (e) => {
    const { checked = "", name = "" } = e.target || {};
    setQuery({ ...query, [name]: checked ? "public" : "private" });

  }
  const {
    access = "",
    freightMode = "",
    message = "",
    name = "",
    qtyMode = "",
    laycanStartDate = null,
    laycanEndDate = null,
    Tag1 = "",
    Tag2 = "",
    Tag3 = "",
    Tag4 = "",
    Attachments = [],
  } = query || {};

  let showMinMax = false;
  if (qtyMode === "MINMAX") showMinMax = true;

  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleOpenInNewTab = (url) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  // Separate Attachments and videos based on file extensions
  const mediaTypes = useMemo(() => {
    const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.bmp', '.tiff'];
    const videoExtensions = ['.mp4', '.avi', '.mov', '.wmv', '.flv', '.webm', '.mkv'];
    const documentExtensions = ['.pdf', '.doc', '.docx', '.odt', '.xls', '.xlsx', '.csv', '.xlsm', '.ppt', '.pptx', '.odp', '.txt'
    ];
    const sortedMedia = {
      images: [],
      videos: [],
      documents: []
    };

    Attachments.forEach(url => {
      url = url?.url || url

      const extension = url?.substring(url?.lastIndexOf('.')).toLowerCase();

      if (imageExtensions.includes(extension)) {
        sortedMedia.images.push(url);
      } else if (videoExtensions.includes(extension)) {
        sortedMedia.videos.push(url);
      } else if (documentExtensions.includes(extension)) {
        sortedMedia.documents.push(url);
      }
    });

    return sortedMedia;
  }, [Attachments]);

  const handleFileSelect = (event) => {
    const files = Array.from(event.target.files);
    setAttachmentFiles(prevFiles => [...prevFiles, ...files]);
  };
  const handleRemoveFile = (item) => {
    if (typeof item === 'number') {
      setAttachmentFiles((prevFiles) => prevFiles.filter((_, i) => i !== item));
    }
    // Check if the item is a URL (from mediaTypes.images)
    else if (typeof item === 'string') {
      // Remove from images in currentData
      const updatedFiles = Attachments.filter((url) => url !== item);

      setQuery((prevData) => ({
        ...prevData,
        Attachments: updatedFiles
      }));
    }
    setAttachmentFiles((prevFiles) => prevFiles.filter((_, i) => i !== item));
  };

  // Table styling matching /orders tab (light gray header, pale yellow cells, charcoal text)
  const thClass = "px-1.5 py-0.5 text-left border-r border-b border-slate-300 text-[11px] font-medium text-slate-900 bg-[#f0f2f5] capitalize tracking-wider align-middle";
  const tdClass = "border border-slate-300 p-0 align-middle bg-white";
  const tableInputClass = "w-full h-[19px] text-[11px] px-1.5 py-0 m-0 box-border block outline-none focus:bg-white focus:ring-1 focus:ring-inset focus:ring-amber-600 bg-[#ffffd6] text-slate-900 disabled:bg-slate-200/50 disabled:text-slate-500 disabled:cursor-not-allowed rounded-none border-none placeholder:text-gray-400 font-medium text-left";

  return (
    <Fragment>
      <div className="w-full bg-white flex flex-col font-sans p-1">
        {/* ── CARGO OPERATIONS TABLE ────────────────────────────────────────── */}
        <div className="flex justify-between items-center mb-0.5 mt-0">
          <h3 className="text-[11px] font-medium text-slate-900 capitalize tracking-wider m-0">
            Cargo Operations
          </h3>
        </div>

        <div className="overflow-x-auto w-full mb-1.5">
          <table className="w-full text-left border-collapse border border-slate-300 whitespace-nowrap table-fixed">
            <thead>
              <tr>
                <th className={`${thClass} w-[26px] min-w-[26px]`}>Add</th>
                <th className={`${thClass} w-[80px]`}>Operation</th>
                <th className={`${thClass} w-[100px]`}>Port</th>
                {showMinMax ? (
                  <>
                    <th className={`${thClass} w-[60px]`}>Min</th>
                    <th className={`${thClass} w-[60px]`}>Max</th>
                  </>
                ) : (
                  <>
                    <th className={`${thClass} w-[60px]`}>Cargo Qty</th>
                    <th className={`${thClass} w-[50px]`}>Tol(%)</th>
                  </>
                )}
                <th className={`${thClass} w-[60px]`}>Rate MT/D</th>
                <th className={`${thClass} w-[70px]`}>Terms</th>
                <th className={`${thClass} w-[50px]`}>Turn(d)</th>
                <th className={`${thClass} w-[60px]`}>Freight</th>
                <th className={`${thClass} w-[50px]`}>Adcom%</th>
                <th className={`${thClass} w-[50px]`}>Other%</th>
                <th className={`${thClass} w-[55px]`}>Broker%</th>
                <th className={`${thClass} w-[85px]`}>Counter Party</th>
                <th className={`${thClass} w-[75px]`}>Cargo Name</th>
                <th className={`${thClass} w-[70px]`}>Stow Factor</th>
                <th className={`${thClass} w-[24px] max-w-[24px]`}></th>
              </tr>
            </thead>
            <tbody>
              {portOperations.map((item, index) => {
                const {
                  operation = "",
                  port = "",
                  cargoQty = "",
                  tolerance = "",
                  rate = "",
                  terms = "",
                  turnTime = "",
                  freight = "",
                  min = 0,
                  max = 0,
                  adcom = "",
                  other = "",
                  brokerage = "",
                  account = "",
                  cargo = "",
                  stowFactor = "",
                } = item || {};

                const firstLoadingIndex = portOperations.findIndex(
                  (op) => op?.operation?.toLowerCase() === "loading"
                );
                const disableForSingleFreight =
                  (freightMode === "Single Freight" && index !== firstLoadingIndex) || false;

                if (
                  item?.operation?.toLowerCase() !== "loading" &&
                  item?.operation?.toLowerCase() !== "discharging"
                ) {
                  return null;
                }

                return (
                  <tr className="hover:bg-[#ffffcc]/60 group" key={index}>
                    <td className={`${tdClass} w-[26px] min-w-[26px] text-center bg-slate-50`}>
                      <div className="flex items-center justify-center w-full h-[19px]">
                        <BiPlusCircle
                          size={14}
                          className="cursor-pointer text-blue-600 hover:text-blue-800"
                          onClick={() => onAddPortOperations(index)}
                        />
                      </div>
                    </td>

                    <td className={tdClass}>
                      <div className="relative">
                        <select
                          disabled={index < 1}
                          value={operation}
                          name="operation"
                          className={`${tableInputClass} appearance-none pr-4`}
                          onChange={(e) => onChangePortOperation(index, e)}
                        >
                          <option value="Commence" disabled hidden>Commence</option>
                          <option value="Loading">Loading</option>
                          <option value="Discharging">Discharging</option>
                        </select>
                        <span className="pointer-events-none absolute right-1 top-1/2 -translate-y-1/2 text-slate-500">
                          <LuChevronDown size={12} />
                        </span>
                      </div>
                    </td>

                    <td className={tdClass}>
                      <div
                        className={`${tableInputClass} flex items-center justify-between cursor-pointer`}
                        onClick={() => onSelectPortsOfOperations(item, index)}
                      >
                        <span className="truncate block w-full">
                          {port || <span className="text-gray-400">Select Port</span>}
                        </span>
                      </div>
                    </td>

                    {(showMinMax ? [min, max] : [cargoQty, tolerance]).map(
                      (val, i) => {
                        const isDisabled = showMinMax
                          ? queryPortDisabledFields?.[operation]?.[i === 0 ? "min" : "max"]
                          : queryPortDisabledFields?.[operation]?.[i === 0 ? "cargoQty" : "tolerance"];
                        return (
                          <td key={i} className={`${tdClass} ${isDisabled ? "!bg-[#9c9c9c]/25" : ""}`}>
                            <input
                              type="number"
                              onKeyDown={handleKeyDown}
                              value={val}
                              name={showMinMax ? (i === 0 ? "min" : "max") : (i === 0 ? "cargoQty" : "tolerance")}
                              disabled={isDisabled}
                              onChange={(e) => onChangePortOperation(index, e)}
                              className={tableInputClass}
                              placeholder="0"
                            />
                          </td>
                        );
                      },
                    )}

                    {[
                      { name: "rate", value: rate },
                      { name: "terms", value: terms },
                      { name: "turnTime", value: turnTime },
                      { name: "freight", value: freight },
                      { name: "adcom", value: adcom },
                      { name: "other", value: other },
                      { name: "brokerage", value: brokerage },
                    ].map((field, i) => {
                      const isDisabled =
                        queryPortDisabledFields?.[operation]?.[field.name] ||
                        (["freight", "adcom", "other", "brokerage"].includes(field.name) && disableForSingleFreight);

                      return field.name === "terms" ? (
                        <td key={i} className={`${tdClass} ${isDisabled ? "!bg-[#9c9c9c]/25" : ""}`}>
                          <div className="relative">
                            <select
                              name="terms"
                              value={field.value}
                              disabled={isDisabled}
                              onChange={(e) => onChangePortOperation(index, e)}
                              className={`${tableInputClass} appearance-none pr-4`}
                            >
                              <option value="" disabled hidden>—</option>
                              {termsCoEfficientTable.map((item, idx) => (
                                <option key={idx} value={item.label}>{item.label}</option>
                              ))}
                            </select>
                            <span className="pointer-events-none absolute right-1 top-1/2 -translate-y-1/2 text-slate-500">
                              <LuChevronDown size={12} />
                            </span>
                          </div>
                        </td>
                      ) : (
                        <td key={i} className={`${tdClass} ${isDisabled ? "!bg-[#9c9c9c]/25" : ""}`}>
                          <input
                            type="number"
                            onKeyDown={handleKeyDown}
                            value={field.value}
                            name={field.name}
                            disabled={isDisabled}
                            onChange={(e) => onChangePortOperation(index, e)}
                            className={tableInputClass}
                            placeholder="0"
                          />
                        </td>
                      );
                    })}

                    {[
                      { name: "account", value: account },
                      { name: "cargo", value: cargo },
                      { name: "stowFactor", value: stowFactor, type: "number" },
                    ].map((field, i) => {
                      const isDisabled = queryPortDisabledFields?.[operation]?.[field.name];
                      return (
                        <td key={i} className={`${tdClass} ${isDisabled ? "!bg-[#9c9c9c]/25" : ""}`}>
                          <input
                            type={field.type || "text"}
                            value={field.value}
                            name={field.name}
                            disabled={isDisabled}
                            onChange={(e) => onChangePortOperation(index, e)}
                            className={tableInputClass}
                            placeholder="—"
                          />
                        </td>
                      );
                    })}

                    <td className={`${tdClass} w-[24px] max-w-[24px] text-center bg-slate-100`}>
                      <div className="flex items-center justify-center w-full h-[19px]">
                        {index > 0 && (
                          <FaRegTrashAlt
                            className="text-rose-500 cursor-pointer hover:text-rose-700"
                            size={12}
                            onClick={() => onDeletePortOperations(index)}
                          />
                        )}
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        {/* ── CONFIGURATION + REMARKS ──────────────────────────────────────── */}
        <div className="flex flex-col md:flex-row gap-2 py-2 border-t border-slate-200 bg-white w-full">
          {/* Configuration Panel */}
          <div className="flex flex-col gap-1.5 bg-[#f8fafc] border border-slate-200 rounded-none p-2 shadow-2xs w-full md:w-[42%]">
            <h3 className="text-[11px] font-medium text-slate-900 capitalize tracking-wider border-b border-slate-200 pb-0.5 mb-0">
              Configuration
            </h3>

            <div className="flex flex-col gap-0.5">
              <label className="text-[11px] font-medium text-slate-900 capitalize tracking-wider">
                Name
              </label>
              <input
                className="w-full text-[11px] px-2 py-0.5 border border-slate-300 rounded-none focus:border-slate-800 outline-none text-slate-900 bg-white shadow-2xs h-6.5"
                placeholder="e.g. Wheat Cargo Q1"
                value={name || ""}
                name="name"
                onChange={onChangeHandler}
              />
            </div>

            <div className="grid grid-cols-2 gap-2">
              <div className="flex flex-col gap-0.5">
                <label className="text-[11px] font-medium text-slate-900 capitalize tracking-wider">
                  Freight Mode
                </label>
                <select
                  value={freightMode || ""}
                  onChange={onChangeHandler}
                  name="freightMode"
                  className="w-full text-[11px] px-2 py-0.5 border border-slate-300 rounded-none focus:border-slate-800 outline-none text-slate-900 bg-white shadow-2xs h-6.5"
                >
                  <option value="Single Freight">Voyage (Single)</option>
                  <option value="Multiple Freight">Multiple Freight</option>
                </select>
              </div>
              <div className="flex flex-col gap-0.5">
                <label className="text-[11px] font-medium text-slate-900 capitalize tracking-wider">
                  Qty Option
                </label>
                <select
                  value={qtyMode || ""}
                  onChange={onChangeHandler}
                  name="qtyMode"
                  className="w-full text-[11px] px-2 py-0.5 border border-slate-300 rounded-none focus:border-slate-800 outline-none text-slate-900 bg-white shadow-2xs h-6.5"
                >
                  <option value="MOLOO">MOLOO</option>
                  <option value="MINMAX">MINMAX</option>
                </select>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-2">
              <div className="flex flex-col gap-0.5">
                <label className="text-[11px] font-medium text-slate-900 capitalize tracking-wider">
                  Laycan Start
                </label>
                <MuiPickersUtilsProvider utils={MomentUtils}>
                  <KeyboardDateTimePicker
                    autoOk
                    inputVariant="outlined"
                    format="DD-MM-YY HH:mm"
                    placeholder="dd-mm-yy hh:mm"
                    value={laycanStartDate || null}
                    onChange={(date) => onChangeDate("laycanStartDate", date)}
                    className="custom-date-time-picker w-full bg-white [&_.MuiOutlinedInput-root]:h-6.5 [&_.MuiOutlinedInput-root]:rounded-none [&_.MuiOutlinedInput-input]:p-1 [&_.MuiOutlinedInput-notchedOutline]:border-slate-300 [&_.MuiOutlinedInput-adornedEnd]:pr-1"
                    size="small"
                    InputProps={{ style: { fontSize: "11px", padding: 0 } }}
                    KeyboardButtonProps={{ style: { padding: 1 } }}
                    disableMaskedInput={true}
                  />
                </MuiPickersUtilsProvider>
              </div>
              <div className="flex flex-col gap-0.5">
                <label className="text-[11px] font-medium text-slate-900 capitalize tracking-wider">
                  Laycan End
                </label>
                <MuiPickersUtilsProvider utils={MomentUtils}>
                  <KeyboardDateTimePicker
                    autoOk
                    inputVariant="outlined"
                    format="DD-MM-YY HH:mm"
                    placeholder="dd-mm-yy hh:mm"
                    value={laycanEndDate || null}
                    onChange={(date) => onChangeDate("laycanEndDate", date)}
                    className="custom-date-time-picker w-full bg-white [&_.MuiOutlinedInput-root]:h-6.5 [&_.MuiOutlinedInput-root]:rounded-none [&_.MuiOutlinedInput-input]:p-1 [&_.MuiOutlinedInput-notchedOutline]:border-slate-300 [&_.MuiOutlinedInput-adornedEnd]:pr-1"
                    size="small"
                    InputProps={{ style: { fontSize: "11px", padding: 0 } }}
                    KeyboardButtonProps={{ style: { padding: 1 } }}
                    disableMaskedInput={true}
                    refuse={/[^\d\s-:]/g}
                  />
                </MuiPickersUtilsProvider>
              </div>
            </div>

            <div className="flex gap-4 mt-0.5">
              {refreshCanalOptions.map((item, index) => {
                return (
                  <div key={index} className="flex items-center gap-1.5">
                    <input
                      type="checkbox"
                      id={item.value}
                      name={item.value}
                      checked={query[item.value] || false}
                      onChange={onChangeHandler}
                      className="h-3.5 w-3.5 border-slate-300 rounded cursor-pointer"
                    />
                    <label
                      htmlFor={item.value}
                      className="cursor-pointer text-[11px] font-medium text-slate-700 leading-none"
                    >
                      {item.label}
                    </label>
                  </div>
                );
              })}
            </div>

            <div className="flex flex-col gap-0.5 mt-0">
              <div className="flex justify-between items-center mb-0.5">
                <label className="text-[11px] font-medium text-slate-800 capitalize tracking-wider">
                  Attachments
                </label>
                {(mediaTypes.images.length > 0 ||
                  mediaTypes.videos.length > 0 ||
                  mediaTypes.documents.length > 0) && (
                    <button
                      type="button"
                      onClick={handleOpen}
                      className="text-[10px] flex items-center gap-1 text-slate-800 border-none font-medium hover:underline bg-transparent p-0 m-0 leading-none cursor-pointer"
                    >
                      <MdLink size={12} /> View Saved ({mediaTypes.images.length + mediaTypes.videos.length + mediaTypes.documents.length})
                    </button>
                  )}
              </div>

              <div
                className="border border-dashed border-slate-400 bg-white rounded-none flex justify-center items-center cursor-pointer hover:bg-slate-50 transition-colors py-1.5"
                onClick={() => fileInputRef.current?.click()}
              >
                <div className="flex items-center gap-1.5">
                  <MdOutlineFileUpload size={14} className="text-slate-700" />
                  <span className="text-[11px] font-medium text-slate-600">
                    Click or drop to upload files
                  </span>
                </div>
                <input
                  type="file"
                  ref={fileInputRef}
                  className="hidden"
                  multiple
                  accept="image/*"
                  onChange={handleFileSelect}
                />
              </div>

              {AttachmentFiles.length > 0 && (
                <div className="mt-1 max-h-[100px] overflow-y-auto border border-slate-200 rounded-none">
                  {AttachmentFiles.map((file, index) => (
                    <div
                      key={index}
                      className="flex justify-between items-center px-2 py-1 text-[11px] bg-white border-b border-slate-100 last:border-0"
                    >
                      <span className="truncate text-slate-600 w-[90%]">
                        {file.name}
                      </span>
                      <button
                        type="button"
                        onClick={() => handleRemoveFile(index)}
                        className="text-slate-400 hover:text-rose-500 bg-transparent border-none p-0 m-0 cursor-pointer"
                      >
                        <MdClose size={12} />
                      </button>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>

          {/* Remarks / Notes Panel */}
          <div className="flex flex-col gap-1.5 bg-[#f8fafc] border border-slate-200 rounded-none p-2 shadow-2xs w-full md:w-[58%]">
            <h3 className="text-[11px] font-medium text-slate-900 capitalize tracking-wider border-b border-slate-200 pb-0.5 mb-0">
              Remarks / Notes
            </h3>
            <textarea
              className="w-full flex-1 min-h-[185px] p-2 text-[11px] border border-slate-300 rounded-none focus:border-slate-800 outline-none text-slate-800 bg-white resize-none shadow-2xs leading-relaxed"
              placeholder="Enter internal notes, special instructions, or terms here..."
              value={message}
              name="message"
              onChange={onChangeHandler}
            />
          </div>

          <Dialog
            open={open}
            onClose={handleClose}
            maxWidth="sm"
            fullWidth
            className={classes.root}
          >
            <DialogTitle className={classes.dialogTitle}>
              <div className="flex-grow">
                Review Media
              </div>
              <IconButton
                onClick={handleClose}
                className={classes.closeButton}
                style={{ position: 'absolute', right: 8, top: 8 }}
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>

            <DialogContent dividers className={classes.dialogContent}>
              {/* Images Section */}
              {mediaTypes.images.length > 0 && (
                <div className="mb-6">
                  <h3 className="text-lg font-semibold mb-4 w-max border-b pb-2">
                    Images ({mediaTypes.images.length})
                  </h3>
                  <div className="grid grid-cols-3 gap-4">
                    {mediaTypes.images.map((url, index) => (
                      <div
                        key={index}
                        className="relative shadow-md shadow-gray-700 hover:shadow-lg transition-shadow overflow-visible"
                      >

                        <button
                          onClick={() => handleRemoveFile(url)}
                          className="absolute -top-2 -right-2 z-10 bg-rose-500 text-white rounded-full hover:bg-rose-600 transition-colors 
                              shadow-md hover:shadow-lg 
                              focus:outline-none focus:ring-2 focus:ring-rose-300"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-5 w-5"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M6 18L18 6M6 6l12 12"
                            />
                          </svg>
                        </button>

                        <div
                          className="cursor-pointer"
                          onClick={() => handleOpenInNewTab(url)}
                        >
                          <img
                            src={url}
                            alt={`Image ${index + 1}`}
                            className="w-full h-[5rem] object-cover"
                          />
                          <div className="p-1 bg-gray-100 text-center">
                            <span className="text-sm truncate">
                              Image {index + 1}
                            </span>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Videos Section */}
              {mediaTypes.videos.length > 0 && (
                <div>
                  <h3 className="text-lg font-semibold mb-4 w-max border-b pb-2">
                    Videos ({mediaTypes.videos.length})
                  </h3>
                  <div className={classes.linkList} style={{ overflow: "visible" }}>
                    {mediaTypes.videos.map((url, index) => (
                      <div
                        key={index}
                        className="flex items-center justify-between w-full p-3 border-b border-gray-200 hover:bg-gray-50 transition-colors duration-200 "
                      >
                        <div className="flex items-center space-x-3 relative">

                          <button
                            onClick={() => handleRemoveFile(url)}
                            className="absolute -top-7 right-[-9.5rem] z-10 bg-rose-500 text-white rounded-full p-1 
                              hover:bg-rose-600 transition-colors 
                                shadow-md hover:shadow-lg 
                                focus:outline-none focus:ring-2 focus:ring-rose-300"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              className="h-4 w-4"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2.5"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M6 18L18 6M6 6l12 12"
                              />
                            </svg>
                          </button>

                          <div className="bg-blue-100 text-blue-800 px-2 py-1 rounded-full text-xs font-semibold">
                            Video {index + 1}
                          </div>
                          <span
                            className="text-sm text-gray-700 max-w-[300px] truncate"
                            title={url}
                          >
                            {url.split('/').pop()}
                          </span>
                        </div>
                        <Button
                          variant="outlined"
                          color="primary"
                          size="small"
                          startIcon={<LaunchIcon />}
                          onClick={() => handleOpenInNewTab(url)}
                          className="ml-4"
                        >
                          Open Link
                        </Button>
                      </div>
                    ))}
                  </div>
                </div>
              )}
              {mediaTypes.documents.length > 0 && (
                <div>
                  <h3 className="text-lg font-semibold mb-4 mt-4 w-max border-b pb-2">
                    Documents ({mediaTypes.documents.length})
                  </h3>
                  <div className={classes.linkList} style={{ overflow: "visible" }}>
                    {mediaTypes.documents.map((url, index) => (
                      <div
                        key={index}
                        className="flex items-center justify-between w-full p-3 border-b border-gray-200 hover:bg-gray-50 transition-colors duration-200 "
                      >
                        <div className="flex items-center space-x-3 relative">

                          <button
                            onClick={() => handleRemoveFile(url)}
                            className="absolute -top-7 right-[-9.5rem] z-10 bg-rose-500 text-white rounded-full p-1 
                              hover:bg-rose-600 transition-colors 
                                shadow-md hover:shadow-lg 
                                focus:outline-none focus:ring-2 focus:ring-rose-300"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              className="h-4 w-4"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2.5"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M6 18L18 6M6 6l12 12"
                              />
                            </svg>
                          </button>

                          <div className="bg-blue-100 text-blue-800 px-2 py-1 rounded-full text-xs font-semibold">
                            Document {index + 1}
                          </div>
                          <span
                            className="text-sm text-gray-700 max-w-[300px] truncate"
                            title={url}
                          >
                            {url.split('/').pop()}
                          </span>
                        </div>
                        <Button
                          variant="outlined"
                          color="primary"
                          size="small"
                          startIcon={<LaunchIcon />}
                          onClick={() => handleOpenInNewTab(url)}
                          className="ml-4"
                        >
                          Open Link
                        </Button>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* No Media Message */}
              {mediaTypes.images.length === 0 && mediaTypes.videos.length === 0 && (
                <div className="text-center text-gray-500 py-4">
                  No media available
                </div>
              )}
            </DialogContent>

            <DialogActions>
              <Button
                onClick={handleClose}
                color="secondary"
              >
                Close
              </Button>
            </DialogActions>
          </Dialog>
        </div>
        <UploadPDFModal
          open={getOpenUploadPDF}
          handleClose={() => setOpenUploadPDF(false)}
          setPortOperations={setPortOperations}
          setQuery={setQuery}
          query={query}
        />
        <CustomShowModal
          open={portModal}
          handleClose={onClosePortModal}
          maxWidth="xs"
          disableClose
          title={`Change ${selectedPort.operation} Port`}
        >
          <AddPortQueryModal
            // onClosePortModal={onClosePortModal}
            selectedPort={selectedPort}
            setSelectedPort={setSelectedPort}
            onSavePortOperationsOfQuery={onSavePortOperationsOfQuery}
          />
        </CustomShowModal>
      </div>
    </Fragment>
  );
});

export default CargoViewModel;
